import * as React from "react";
import {useContext, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {useParams} from "react-router-dom";

function ImportPriority(props) {
    const title = 'Import Peseli';
    const description = (<>Tutaj możesz zaimportować listę peseli do automatycznej akceptacji zapisów - brana pod uwagę jest tylko pierwsza kolumna pliku CSV. <strong>Przed importem baza peseli jest czyszczona.</strong></>);
    const params = useParams();
    const [user] = useContext(AuthContext);
    const [file, setFile] = useState(null);

    function _submitFile() {
        if (file !== null) {
            const data = new FormData();
            data.append('file', file);
            fetch(`/api/season/${params.id}/import`, {
                method: 'post',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { props.onSuccess(data); props.dismiss(); })
                .catch(err => { console.log(err) })
        }
    }

    return (
        <StyledModal isOpen={props.isOpen} title={title} description={description} send={_submitFile} dismiss={props.dismiss} actionLabel={'Importuj CSV (Separator ";")'}>
            <form>
                <input type="file" name="file" onChange={(e) => setFile(e.target.files[0])}/>
            </form>
        </StyledModal>
    );
}

export default ImportPriority;